import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { App as AntApp } from 'antd';
import AppRoutes from './routes';
import AppLayout from './components/Layout/AppLayout';
import BreakingNewsTicker from './components/News/BreakingNewsTicker';
import ThemeProvider from './components/ThemeProvider/index';
import { AuthProvider } from './contexts/AuthContext';
import { ErrorProvider } from './contexts/ErrorContext';
import ErrorBoundary from './components/ErrorBoundary';

const App: React.FC = () => {
  return (
    <AntApp>
      <ErrorProvider>
        <ThemeProvider>
          <ErrorBoundary>
            <AuthProvider>
              <Router>
                <AppLayout>
                  <BreakingNewsTicker />
                  <AppRoutes />
                </AppLayout>
              </Router>
            </AuthProvider>
          </ErrorBoundary>
        </ThemeProvider>
      </ErrorProvider>
    </AntApp>
  );
};

export default App;